import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const attendScoreTasks = async (params: object) => {
  return await GET({ url: Api.attendScoreTasks, params, showError: false })
}
